/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Empty_TitleInputs */

const en_us2_progress_empty_title = /** @type {(inputs: Progress_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your progress starts with your first workout`)
};

const pt_br2_progress_empty_title = /** @type {(inputs: Progress_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu progresso começa no primeiro treino`)
};

const es_419_progress_empty_title = /** @type {(inputs: Progress_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu progreso empieza con tu primer entrenamiento`)
};

const pt_pt2_progress_empty_title = /** @type {(inputs: Progress_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu progresso começa no primeiro treino`)
};

const fr_fr2_progress_empty_title = /** @type {(inputs: Progress_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta progression commence avec ta première séance`)
};

const de_de2_progress_empty_title = /** @type {(inputs: Progress_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Fortschritt beginnt mit deinem ersten Training`)
};

const it_it2_progress_empty_title = /** @type {(inputs: Progress_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi progressi iniziano dal primo allenamento`)
};

/**
* | output |
* | --- |
* | "Your progress starts with your first workout" |
*
* @param {Progress_Empty_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_empty_title = /** @type {((inputs?: Progress_Empty_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Empty_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_empty_title(inputs)
	if (locale === "es-419") return es_419_progress_empty_title(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_empty_title(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_empty_title(inputs)
	if (locale === "de-DE") return de_de2_progress_empty_title(inputs)
	if (locale === "it-IT") return it_it2_progress_empty_title(inputs)
	return en_us2_progress_empty_title(inputs)
});
export { progress_empty_title as "progress.empty_title" }